import { Component, Input } from '@angular/core';
import { ImageBreak } from 'src/app/shared/constants/app.constants';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-divider-image',
  templateUrl: './divider-image.component.html',
  styleUrls: ['./divider-image.component.scss']
})
export class DividerImageComponent {

  @Input() srcbreak!:ImageBreak;
  imgSource:string = "";
  langDictionary:any;
  constructor(private _globalService: GlobalService){
  }

  ngOnInit(){
    this.langDictionary = this._globalService.Language; 
    this._globalService.jobInformation.subscribe((data) => {  

      switch (this.srcbreak) {
        case ImageBreak.EventBreak:
          this.imgSource = data?.pageData?.sectionEvents?.imageBelowURL;
          break;

        case ImageBreak.ContentBreak:
          this.imgSource = data?.pageData?.sectionContent?.imageBelowURL;
          break;

        case ImageBreak.SpeakerBreak:
          this.imgSource = data?.pageData?.sectionSpeakers?.imageBelowURL;
          break;
      }
    

    })
    console.log(this.srcbreak)
  }
 ngAfterViewInit() {
  
}

}
